











// @ is an alias to /src
import TopToolbar from "@/components/TopToolbar.vue";
import BottomNav from "@/components/BottomNav.vue";
import { Route } from "@rocketbase/vue-extra-decorators";
import { Component, Vue } from "vue-property-decorator";

@Route({
  name: "Lockers",
  path: "/lockers"
})
@Component({
  components: { TopToolbar, BottomNav }
})
export default class Lockers extends Vue {
  /*@On("hook:mounted")
   private async onMounted() {

   }*/
}
